<nav aria-label="breadcrumb" *ngIf="view$ | async as view">
  <ol class="breadcrumb">
    <li
      class="breadcrumb-item"
      [class]="item.className"
      [class.collapsed]="item.collapsed"
      *ngFor="let item of view.items"
    >
      <span class="separator">
        <fa-icon
          [icon]="['fas', 'angle-right']"
          *ngIf="!item?.className?.includes('dimension')"
        ></fa-icon>
        <fa-icon
          [icon]="['fas', 'link']"
          *ngIf="item?.className?.includes('dimension')"
          [transform]="{ rotate: 25 }"
        ></fa-icon>
      </span>
      <a
        *ngIf="!item.isDropdown"
        class="breadcrumb-item-link"
        [routerLink]="item.url"
        [suiTooltip]="item.tooltip"
        (click)="item.action?.(false)"
      >
        <span class="icon">
          <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
        </span>
        <span class="label" *ngIf="item.kind !== 'period'; else dateItem">
          {{ item.label }}
        </span>
        <ng-template #dateItem>
          <span class="label">
            {{ item.label }}
          </span>
        </ng-template>
        <fa-icon
          *ngIf="item.kind == 'filter' || item.kind == 'period'"
          [icon]="['far', 'times-circle']"
          (click)="item.action?.(true)"
        ></fa-icon>
      </a>
      <div *ngIf="item.isDropdown" class="d-inline-block">
        <a
          class="btn btn-outline-primary breadcrumb-item-link"
          id="dropdownBreadcrumb{{ item.label }}"
          [suiTooltip]="item.tooltip"
          #breadcrumbTooltipRef="suiTooltip"
          [suiMenuTrigger]="breadcrumbMenu"
          #dropdown="suiMenu"
          (openChange)="$event && breadcrumbTooltipRef.close()"
          (click)="navigate(item.url)"
        >
          <span class="icon">
            <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
          </span>
          <span class="label">
            {{ item.label }}
          </span>
          @if (item.algorithmCount) {
            <div
              class="algorithm-indicator"
              (click)="item.algorithmAction?.(); $event.stopPropagation()"
            >
              <fa-icon [icon]="['fas', 'microchip']"></fa-icon>
              <span class="algorithm-count">{{ item.algorithmCount }}</span>
            </div>
          }
          @if (item.autoRefresh) {
            <div class="auto-refresh-icon">
              <fa-icon [icon]="['fas', 'refresh']"></fa-icon>
            </div>
            <span class="auto-refresh-seconds"
              >{{ item.autoRefreshSeconds }}s</span
            >
          }
          @if (item.isPaused) {
            <div
              class="paused-indicator"
              [suiTooltip]="
                item.pausedTimestamp
                  ? 'Updates paused - no new data since ' +
                    (item.pausedTimestamp * 1000
                      | date: NomDateTimeFormats.ANALYTICS_LONG)
                  : 'Updates paused - no new data is being ingested'
              "
            >
              <fa-icon [icon]="['fas', 'pause-circle']"></fa-icon>
              @if (item.pausedTimestamp) {
                <span class="paused-since">
                  {{
                    item.pausedTimestamp * 1000
                      | date: NomDateTimeFormats.ANALYTICS_LONG
                  }}
                </span>
              }
            </div>
          }
          <sui-button
            size="xsm"
            variant="legacy-ghost"
            [leadingIcon]="['fas', 'caret-down']"
            [iconOnly]="true"
            ariaLabel="Open menu"
            [expanded]="dropdown.isOpen()"
          ></sui-button>

          <!-- Dropdown menu -->
        </a>
        <ng-template #breadcrumbMenu>
          <sui-menu>
            <ng-container *ngFor="let dropdownItem of item.dropdownItems">
              <sui-menu-separator
                *ngIf="dropdownItem.isSeparator"
              ></sui-menu-separator>
              <a
                sui-menu-item
                *ngIf="!dropdownItem.isSeparator"
                [routerLink]="dropdownItem.url"
                (click)="
                  dropdownItem.action
                    ? dropdownItem.action()
                    : onDropdownItemClick(dropdownItem)
                "
              >
                <fa-icon
                  *ngIf="dropdownItem.icon"
                  [icon]="dropdownItem.icon"
                ></fa-icon>
                <span>{{ dropdownItem.label }}</span>
              </a>
            </ng-container>
          </sui-menu>
        </ng-template>
      </div>
    </li>

    <!-- Overflow chip: filters beyond the visible cap, removable from the dropdown -->
    <li
      class="breadcrumb-item filter overflow-filters"
      *ngIf="view.overflowFilters.length > 0"
    >
      <span class="separator">
        <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
      </span>
      <div class="d-inline-block">
        <a
          class="breadcrumb-item-link"
          id="dropdownBreadcrumbOverflowFilters"
          [suiTooltip]="'breadcrumb.tooltip.more-active-filters' | translate"
          [suiTooltipContainer]="'body'"
          #overflowTooltip="suiTooltip"
          [suiMenuTrigger]="overflowFiltersMenu"
          (openChange)="$event && overflowTooltip.close()"
          #overflowDropdown="suiMenu"
        >
          <span class="icon">
            <fa-icon [icon]="['fas', 'filter']"></fa-icon>
          </span>
          <span class="label">+{{ view.overflowFilters.length }}</span>
          <sui-button
            variant="ghost"
            size="xsm"
            [leadingIcon]="['fas', 'caret-down']"
            [iconOnly]="true"
            [expanded]="overflowDropdown.isOpen()"
            ariaLabel="Show more filters"
          >
          </sui-button>
        </a>
        <ng-template #overflowFiltersMenu>
          <!-- Plain <a> rows (not sui-menu-item): the menu must stay open so
               several filters can be removed in a row (removeOverflowFilter
               stopPropagation()s); sui-menu-item would auto-close on click. -->
          <sui-menu class="overflow-filters-menu">
            <a
              class="dropdown-item"
              *ngFor="let filterItem of view.overflowFilters"
              [suiTooltip]="filterItem.tooltip"
              [suiTooltipContainer]="'body'"
              (click)="removeOverflowFilter(filterItem, $event)"
            >
              <span class="dropdown-item-link-col1">
                <span class="dropdown-item-link-label">
                  <span>
                    <fa-icon [icon]="['fas', 'filter']"></fa-icon>
                  </span>
                  <span class="overflow-filter-label">{{
                    filterItem.label
                  }}</span>
                  <fa-icon
                    class="remove-icon"
                    [icon]="['far', 'times-circle']"
                  ></fa-icon>
                </span>
              </span>
            </a>
          </sui-menu>
        </ng-template>
      </div>
    </li>
  </ol>
</nav>
